import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { NavbarType } from '../../types';

const Navbar: FunctionComponent<NavbarType> = ({
  logoLink = '',
  logoHashLink = '',
  transparent = false,
  fixedTop = false,
  children,
}): JSX.Element => {
  const PUBLIC_URL = process.env.PUBLIC_URL;

  return (
    <div>
      <nav className={`navbar navbar-expand-lg ${fixedTop ? 'fixed-top' : ''}${!transparent ? ' nav-menu' : ''}`} id="mainNav">
        <div className="container-xl">
          <div className="navbar-brand d-flex align-items-center">
            {!transparent && (
              <>
                <Link
                  to={{ pathname: logoLink }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (logoLink!.length < 1 && logoHashLink!.length > 0) {
                      window.location.href = logoHashLink;
                    }
                  }}
                >
                  <img
                    className="logo-sistema d-block"
                    alt="Sistema de Cadastro de Eleições da UFPB"
                    src={`${PUBLIC_URL}${'/assets/images/logo_sce_orange.svg'}`}
                    title="Sistema de Cadastro de Eleições"
                  />
                </Link>
                <Link
                  to={{ pathname: logoLink }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (logoLink!.length < 1 && logoHashLink!.length > 0) {
                      window.location.href = logoHashLink;
                    }
                  }}
                  className="  d-none d-md-block text-decoration-none "
                >
                  <span className=" fw-bold align-middle px-2 d-block"> Sistema de Cadastro de Eleições</span>
                </Link>
              </>
            )}
          </div>
          <div className="text-end">{children}</div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
